import * as Sentry from '@sentry/nextjs';

/**
 *
 * @param action "ack/noAck"
 * @returns
 */
export async function postUserEvents(data) {
  const url = '/web/v1/captcha/@verify';
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((result) => {
      if (!String(result?.code || result?.meta?.code).startsWith('2')) {
        Sentry.captureException(
          new Error(`postWithAuth API Error: ${JSON.stringify(result)}; url: ${url}; data:${JSON.stringify(data)}`)
        );
      }
      return result;
    })
    .catch((err) => {});
}

// 获取stoken接口

export async function captchaVerify(data) {
  return fetch('/api/captcha', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((result) => {
      if (!String(result?.code || result?.meta?.code).startsWith('2')) {
        Sentry.captureException(
          new Error(
            `postWithAuth API Error: ${JSON.stringify(result)}; url: ${'/api/captcha'}; data:${JSON.stringify(data)}`
          )
        );
      }
      return result;
    })
    .catch((err) => {});
}
